import { giphyCharcoal, giphyDarkCharcoal, giphyDarkGrey } from '@giphy/react-giphy-brand/src/css/colors'
import styled, { css } from 'styled-components'
import PresetComponent from '../../preset'
import InputComponent from './input'

export const Input = styled(InputComponent)`
    margin-bottom: 10px;
`

export const Preset = styled(PresetComponent)<{ $active: boolean }>`
    margin: 0 5px 5px;

    ${({ $active }) =>
        $active
            ? css`
                  background: ${giphyCharcoal};
              `
            : css`
                  background: ${giphyDarkGrey};
                  transition: background 0.1s ease-out;

                  &:hover {
                      background: ${giphyDarkCharcoal};
                  }
              `}
`
